// @flow
import React from 'react'
import dynamic from 'next/dynamic'

import en from 'date-fns/locale/en-US'
import cs from 'date-fns/locale/cs'

import { Flex, Label } from 'components/common'
import { useDateTimePickerStyles } from './styles'

// $FlowFixMe
import 'react-datepicker/dist/react-datepicker.css'

const ReactDatepicker = dynamic(() => import('react-datepicker'), {
  ssr: false
})

const getLocale = () => {
  const language = typeof window === 'undefined' ? 'cz' : window.navigator.language
  const [base] = language.split('-')

  switch (base) {
    case 'cs':
      return cs
    case 'en':
      return en
    default:
      return cs
  }
}

const locale = getLocale()

type DateTimePickerProps = {
  id?: string,
  label?: string,
  value?: Date | string,
  showTimeSelect?: boolean,
  dateFormat?: string,
  timeFormat?: string,
  wrapperProps?: { [key: string]: any },
  onChange?: (date: Date | null) => void
}

const DateTimePicker = ({
  id,
  label,
  value,
  showTimeSelect = false,
  dateFormat = 'd.M.yyyy HH:mm',
  timeFormat = 'HH:mm',
  wrapperProps = {},
  onChange = () => {},
  ...props
}: DateTimePickerProps) => {
  const classes = useDateTimePickerStyles()

  return (
    <Flex column {...wrapperProps}>
      {label && <Label id={id && `${id}-label`}>{label}</Label>}
      <ReactDatepicker
        className={classes.dateTimePicker}
        dateFormat={dateFormat}
        locale={locale}
        selected={value ? new Date(value) : new Date()}
        showTimeSelect={showTimeSelect}
        timeFormat={timeFormat}
        onChange={onChange}
        {...props}
      />
    </Flex>
  )
}

export { DateTimePicker }
